export const capitalize = <T extends string>(s: T) =>
    (s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase()) as Capitalize<typeof s>;
